import { addressWithFull, contactInfo } from '../common';

export const organization = {
  ehrId: '',
  name: '',
  isPrimary: false,
  address: addressWithFull,
  contact_info: contactInfo,
};
